import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import OrderPageContent from "./OrderPageContent";
import { PurchaseOrderBuilderPage } from "../PurchaseOrderBuilderPage";
import { useGetOrderEditData } from "../../hooks";
import { PageContent } from "../../components";

const OrderPage = () => {
  const { id } = useParams();

  const [searchParams] = useSearchParams();
  const isVendor = searchParams.get("isVendor");

  const { data, isLoading } = useGetOrderEditData(Number(id));

  const useVendorOrder = isVendor || data?.isOutbound;
  return (
    <PageContent isLoading={isLoading} disablePadding hideOverflow>
      {useVendorOrder ? (
        <PurchaseOrderBuilderPage id={id} />
      ) : (
        <OrderPageContent />
      )}
    </PageContent>
  );
};

export default OrderPage;
